import CTABtn from "components/CTABtn"
import { Column } from "components/Layout"
import * as gamesAPI from "modules/gamesAPI"
import colors from "styles/colors"

export default function ErrorGeneral({ error }) {
  let title = "Oops, this is embarrassing…"
  let description = (
    <>
      It appears that something didn’t go as planned.
      <br />
      So sorry about that!
    </>
  )
  let techDetails = null
  let reloadAction = () => window.location.reload()

  if (error.url && error.errorCode === 404) {
    if (/\/tabs\/[0-9]{1,4}\/feed/.test(error.url)) {
      title = "Tab could not be found"
      reloadAction = () => window.history.back()
    } else if (/\/tabs/.test(error.url)) {
      title = "Could not load tabs list"
      reloadAction = () => window.history.back()
    } else if (/\/apps/.test(error.url)) {
      title = "App could not be found"
      reloadAction = () => window.history.back()
    } else if (/\/app_collection/.test(error.url)) {
      title = "App Collection could not be found"
      reloadAction = () => window.history.back()
    }
  } else {
    techDetails = (
      <>{error && <pre style={{ width: "100%" }}>{error.toString()}</pre>}</>
    )
  }

  function reload() {
    // TODO: should we reload the current page or get back to the home page?
    // We can't always know the actual home page, it might be on a path like:
    // gems.com/versions/latest
    reloadAction()
  }

  return (
    <Column
      align="mc"
      style={{ textAlign: "center", height: "100%" }}
      padding="2rem"
      gap="1rem"
    >
      <img
        src="/img/error_general.png"
        width={180}
        height={180}
        alt="error occured"
      />
      <h3>{title}</h3>
      <h4 style={{ color: colors.textMedium }}>{description}</h4>
      <CTABtn type="large" iconLeft="reload" onClick={reload}>
        Reload the app
      </CTABtn>
      {techDetails}

      <Column align="mc" padding="1rem" style={{ color: colors.textMedium }}>
        <small>User ID: {gamesAPI.userId()}</small>
        <small>Session ID: {gamesAPI.sessionId()}</small>
      </Column>
    </Column>
  )
}
